/**
 * Utilidad de persistencia para Chatbot Wizard v2
 * Guarda y carga el estado del flujo en localStorage
 */

const CHAT_HISTORY_KEY = 'nawaiam_chat_history';

/**
 * Guarda el estado completo del chatbot en localStorage
 */
export const saveChatHistory = (data) => {
  try {
    const storageData = {
      // `isOpen` se persiste porque la redirección a una sección recarga la
      // página: sin esto el chat se cerraría en cada navegación (NW-2425).
      isOpen: data.isOpen,
      currentStep: data.currentStep,
      currentSection: data.currentSection,
      currentQuestion: data.currentQuestion,
      navigationStack: data.navigationStack,
      messages: data.messages,
      timestamp: new Date().toISOString(),
    };
    localStorage.setItem(CHAT_HISTORY_KEY, JSON.stringify(storageData));
  } catch (error) {
    console.error('Failed to save chat history:', error);
  }
};

/**
 * Carga el estado del chatbot desde localStorage
 */
export const loadChatHistory = () => {
  try {
    const stored = localStorage.getItem(CHAT_HISTORY_KEY);
    if (stored) {
      const data = JSON.parse(stored);
      return {
        isOpen: data.isOpen || false,
        currentStep: data.currentStep || 'welcome',
        currentSection: data.currentSection || null,
        currentQuestion: data.currentQuestion || null,
        navigationStack: data.navigationStack || [],
        messages: data.messages || [],
      };
    }
    return null;
  } catch (error) {
    console.error('Failed to load chat history:', error);
    return null;
  }
};

/**
 * Limpia el historial del chatbot
 */
export const clearChatHistory = () => {
  try {
    localStorage.removeItem(CHAT_HISTORY_KEY);
  } catch (error) {
    console.error('Failed to clear chat history:', error);
  }
};

/**
 * Verifica si existe historial guardado
 */
export const hasHistory = () => {
  try {
    return localStorage.getItem(CHAT_HISTORY_KEY) !== null;
  } catch (error) {
    return false;
  }
};
